/**
 * Tipos de localização de ativo (issue #300, RN03).
 *
 * A localização é onde o ativo está fisicamente/operacionalmente alocado,
 * distinta do responsável pela guarda (RN07). Os rótulos são compartilhados
 * entre o cadastro de localidades e as telas de ativo para não divergirem.
 */
export type LocationType =
  | 'company_unit'
  | 'client'
  | 'warehouse'
  | 'remote'
  | 'technical_assistance'
  | 'in_transit'
  | 'other';

export const LOCATION_TYPE_LABELS: Record<LocationType, string> = {
  company_unit: 'Unidade da empresa',
  client: 'Cliente',
  warehouse: 'Estoque/Almoxarifado',
  remote: 'Home office/Remoto',
  technical_assistance: 'Assistência técnica',
  in_transit: 'Em trânsito',
  other: 'Outro',
};

export const LOCATION_TYPE_OPTIONS = (
  Object.keys(LOCATION_TYPE_LABELS) as LocationType[]
).map((value) => ({ value, label: LOCATION_TYPE_LABELS[value] }));

export function locationTypeLabel(type?: string | null): string {
  if (!type) return 'Não informado';
  return LOCATION_TYPE_LABELS[type as LocationType] ?? type;
}

/** Forma mínima de localização que chega nas telas de ativo. */
export interface LocationLike {
  name: string;
  type?: LocationType | string | null;
  clientName?: string | null;
}

/**
 * Rótulo de exibição: nome + tipo, com o cliente quando houver (RN05).
 * Ex.: `Cliente XYZ – Brasília · Cliente (Cliente XYZ)`.
 */
export function formatLocationLabel(location?: LocationLike | null): string {
  if (!location) return '';
  const parts = [location.name, locationTypeLabel(location.type)];
  if (location.clientName) parts.push(location.clientName);
  return parts.join(' · ');
}
